var publicPath = __webpack_public_path__;
                    module.exports = {
                        symbol: publicPath + 'sprite.svg#icon-insta',
                        view: publicPath + 'sprite.svg#view-icon-insta',
                        viewBox: '0 0 15.807 15.993',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };